import { Button, Form } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../Common/Input';
import Layout from './Layout';
import { ForgotPasswordText, Title } from './Login';

function formatEmail(email: string): string {
  const [localPart, domain] = email.split('@');

  // Format local part: show the first 3 characters, hide the rest
  const formattedLocalPart = localPart.substring(0, 3) + '***';

  // Format domain: hide part after the '.' (TLD)
  const domainParts = domain.split('.');
  const formattedDomain = domainParts[0] + '.***';

  return `${formattedLocalPart}@${formattedDomain}`;
}

type Props = {
  onFinish: (values: any) => Promise<{
    success?: boolean;
    errors?: { field: string; errors: string[] }[];
  }>;
  email: string;
};
const ForgotPassMerchantStep2 = ({ onFinish, email }: Props) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const emailFormat = formatEmail(email);

  return (
    <Layout>
      <Form
        layout="vertical"
        form={form}
        onFinish={async (value) => {
          setIsSubmiting(true);
          const res = await onFinish(value);

          if (res.errors) {
            const arr = res.errors.map((x) => {
              return {
                name: x.field,
                errors: x.errors,
              };
            });
            form.setFields(arr);
            form.scrollToField(arr[0].name);
          }
          setIsSubmiting(false);
        }}
      >
        <Title>Xác nhận khôi phục mật khẩu</Title>
        <div style={{ padding: '16px 0 16px' }}>
          {`Mã xác minh đã được gửi đến địa chỉ email ${emailFormat} nếu email
 này đã trở thành đối tác nhà hàng của YouGo. Vui lòng kiểm tra hộp thư
 để lấy mã và nhập vào bên dưới`}
        </div>
        <Form.Item
          label="Mã xác nhận"
          name="code"
          rules={[{ required: true, message: 'Vui lòng nhập mã xác nhận!' }]}
        >
          <Input placeholder="Nhập mã xác nhận" />
        </Form.Item>

        <Form.Item>
          <Button loading={isSubmiting} block type="primary" htmlType="submit">
            Tiếp tục
          </Button>
        </Form.Item>
        <Form.Item>
          <ForgotPasswordText onClick={() => navigate('/login')}>
            ← Đăng nhập tài khoản khác
          </ForgotPasswordText>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default ForgotPassMerchantStep2;
